export enum ASSET_TYPES_SORTS {}

export enum ASSET_TYPES_FILTERS {
  ID = "filter[id]",
  ENTITY_TEMPLATE_ID = "filter[entity_template_id]",
}

export enum ASSET_TYPES_FIELDS {
  ASSET_TYPES = "fields[asset_types]",
}
